import { render, staticRenderFns } from "./PvrTicket.vue?vue&type=template&id=21d4f582&"
import script from "./PvrTicket.vue?vue&type=script&lang=js&"
export * from "./PvrTicket.vue?vue&type=script&lang=js&"
import style0 from "./PvrTicket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports